export default __webpack_public_path__ + "static/content_types-1d175201230c5d0b3bca72a93080a7e2.gif";